var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerifyBadge = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#1891FF",
  d: "M20 12c0 1.016-1.177 1.79-1.544 2.674-.38.916-.109 2.293-.8 2.983-.69.69-2.066.42-2.982.8C13.791 18.823 13.016 20 12 20s-1.79-1.177-2.674-1.543c-.916-.38-2.293-.11-2.983-.8s-.42-2.067-.8-2.983C5.177 13.791 4 13.016 4 12s1.177-1.79 1.544-2.674c.38-.916.109-2.293.8-2.983.69-.69 2.066-.42 2.982-.8C10.209 5.178 10.984 4 12 4s1.79 1.177 2.674 1.544c.916.38 2.293.109 2.983.8.69.69.42 2.066.8 2.982C18.822 10.209 20 10.984 20 12"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFF",
  fillRule: "nonzero",
  d: "m14.606 8.368 1.55 1.264-4.808 5.896-2.94-2.156 1.183-1.612 1.407 1.032z"
}))));
export { SvgVerifyBadge as ReactComponent };
export default __webpack_public_path__ + "static/media/verifyBadge.b9234e04.svg";